const fields = Object.freeze({
  otp: 'otp',
  companyName: 'companyName',
  emailAddress: 'emailAddress',
  userFullName: 'userFullName',
  userFirstName: 'userFirstName',
  userLastName: 'userLastName',
  countryId: 'countryId',
  phoneNumber: 'phoneNumber',
  userIdentifier: 'userIdentifier',
  password: 'password',
  confirmPassword: 'confirmPassword',
  securityPin: 'securityPin',
  auth: 'auth',

  firstName: 'firstName',
  lastName: 'lastName',
  number: 'number',
  countryCode: 'countryCode',

  reqTimeStamp: 'reqTimeStamp',
  reqId: 'reqId',
  parsedReqId: 'parsedReqId',
  entityName: 'entityName',
  actionType: 'actionType',
  actionStatus: 'actionStatus',
  status: 'status',
  fxAccountName: 'fxAccountName',
  creationDate: 'creationDate',
  amexContactEmail: 'amexContactEmail',
  digitalAssetGroup: 'digitalAssetGroup',
  protocols: 'protocols',
  environment: 'environment',
  myActions: 'myActions',
  manageDigitalAssets: 'manageDigitalAssets',
  manageContacts: 'manageContacts',
  contactInfo: 'contactInfo',
  updateContactInfo: 'updateContactInfo',
  userDetails: 'userDetails',
  fxAccount: 'fxAccount',
  updatePassword: 'updatePassword',
  home: 'home',
  lastPasswordChangedTime: 'lastPasswordChangedTime',
  activateFxAccount: 'activateFxAccount',
});

export default fields;
